import React from 'react'

// Original sidebar vectors from Figma frame 220, Group 6514.
export default ({ color = '#3C52EF', size = 16, style }) => (
  <svg width={size} height={size} viewBox="28 197 16 16" fill="none" style={style} aria-hidden="true">
    <rect x="28" y="206" width="4" height="7" fill={color} />
    <rect x="34" y="197" width="4" height="16" fill={color} />
    <rect x="40" y="201" width="4" height="12" fill={color} />
  </svg>
)
